export default class CleanUpUserSessionStateError extends Error {

}
